import enLang from './entries/en-US';
import koLang from './entries/ko-KR';

const AppLocale: any = {
    ko: koLang,
    en: enLang,
};

export default AppLocale;
